import { render, staticRenderFns } from "./InternalPreparationsPage.vue?vue&type=template&id=eddba250&scoped=true"
import script from "./InternalPreparationsPage.vue?vue&type=script&lang=js"
export * from "./InternalPreparationsPage.vue?vue&type=script&lang=js"
import style0 from "./InternalPreparationsPage.vue?vue&type=style&index=0&id=eddba250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddba250",
  null
  
)

export default component.exports